/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  CREATE_ATTEND_DAY(state, payload){
    state.attendDays.unshift(payload)
  },
  SET_ATTEND_DAYS(state, payload){
    state.attendDays = payload
  },
  SET_ATTEND_MISS_DATA(state, payload){
    state.attendMissDatas = payload
  },
  SET_ATTEND_LATE_DATE(state, payload){
    state.attendLateDatas = payload
  },
  UPDATE_ATTEND_DAY(state, payload){
    var index = state.attendDays.findIndex(function(item){return item.id == payload.id})
    Object.assign(state.attendDays[index], payload)
  },
  DELETE_ATTEND_DATA(state, attendId){
    var index = state.attendDays.findIndex(function(item){return item.id == attendId})
    if(index != -1){
      state.attendDays.splice(index,1)
    }
  },
  UPDATE_ATTEND_MISS_DATA(state, payload){
    var index = state.attendMissDatas.findIndex(function(item){return item.user_id == payload.user_id})
    if(index == -1){
      state.attendMissDatas.push(payload)
    }
  },
  UPDATE_ATTEND_LATE_DATA(state, payload){
    var index = state.attendLateDatas.findIndex(function(item){return item.user_id == payload.user_id})
    if(index == -1){
      state.attendLateDatas.push(payload)
    }
  },
  DELETE_ATTEND_MISS_DATA(state, payload){
    var index = state.attendMissDatas.findIndex(function(item){return item.user_id == payload.user_id})
    if(index != -1){
      state.attendMissDatas.splice(index,1)
    }
  },
  DELETE_ATTEND_LATE_DATA(state, payload){
    var index = state.attendLateDatas.findIndex(function(item){return item.user_id == payload.user_id})
    if(index != -1){
      state.attendLateDatas.splice(index,1)
    }
  },
  CHANGE_DATE_EVENT(state){
    state.eventFlag = !state.eventFlag
  },
  UPDATE_DATA_EVENT(state){
    state.updateDataFalg = !state.updateDataFalg
  }
  // SET_USERS(state, users) {
  //   state.users = users
  // },
  // REMOVE_RECORD(state, itemId) {
  //     const userIndex = state.users.findIndex((u) => u.id == itemId)
  //     state.users.splice(userIndex, 1)
  // },
}
